import { render, staticRenderFns } from "./LowerBack.vue?vue&type=template&id=e50fe3a2&"
import script from "./LowerBack.vue?vue&type=script&lang=js&"
export * from "./LowerBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports